import { createContext } from "react";
let specont=createContext()
export default specont